<error-401 *ngIf="is401"></error-401>
<error-404 *ngIf="is404"></error-404>

<div *ngIf="!is401 && !is404 && !isLoading" [ngStyle]="{'display': hasData ? 'none': 'block'}">
  <div fxLayout="row" fxLayoutAlign="space-evenly center">
    <div>
      {{ 'NoDataAtTheMoment'|translate }}
    </div>
  </div>
</div>
<div *ngIf="!is401 && !is404 && isLoading">
  <div fxLayout="row" fxLayoutAlign="space-evenly center">
    <div>
      {{ 'LoadingChartData'|translate }}
    </div>
  </div>
</div>

<center-loader *ngIf="!is401 && !is404 && isLoading"></center-loader>

<div class="container" *ngIf="isPvcTest && !is401 && !is404 && !isLoading && (data$ | async)">
  <div *ngFor="let pvc of (selectedPvcMeasure ? [selectedPvcMeasure] : []); trackBy: trackByMeasureId" class="horizontal-scroll-wrapper test-bloc-container tests-header">
    <mat-card-header>
      <div class="header-wrapper">
        <mat-card-subtitle>
          <div class="top-header">
            <mat-chip-set>
              <mat-chip><span>{{ pvc.x | date:'dd.MM.YYYY' }}</span></mat-chip>
            </mat-chip-set>
            <div>
              <button class="edit-delete-measure" mat-mini-fab color="secondary" [matMenuTriggerFor]="pvcMenu">
                <i class="material-icons">more_vert</i>
              </button>
              <mat-menu #pvcMenu="matMenu">
                <button [disabled]="!rights.EDIT" mat-menu-item (click)="edit(pvc.id)">
                  <mat-icon>edit</mat-icon>
                  <span>{{ 'Edit'|translate }}</span>
                </button>
                <button [disabled]="!rights.DELETE" mat-menu-item (click)="delete(pvc.id)">
                  <mat-icon>delete</mat-icon>
                  <span>{{ 'Delete'|translate }}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </mat-card-subtitle>
      </div>
      <div class="test-comment" *ngIf="pvc.comment">
        {{ pvc.comment }}
      </div>
    </mat-card-header>

    <div class="separator"></div>

    <div class="mt-20">
      <div class="mb-40">
        <div class="borg-wrapper">
          <span>{{ 'MeasureResults'|translate }}</span>
        </div>
      </div>
      <div class="charts" fxLayout="row" fxLayoutAlign="space-evenly center">
        <div class="gauge-chart-wrapper" [ngClass]="{'active': currentPvcChart === 'pvc'}">
          <test-empty-gauge-chart
            title="{{ 'PvcTooltipOffset'|translate }}"
            [subject]="subject"
            [data]="pvc.offset"
            [dataBorg]="-1"
          ></test-empty-gauge-chart>
          <button mat-mini-fab color="secondary" (click)="onPvcChartSelectorClicked('pvc')"
                  [ngClass]="{'active': currentPvcChart === 'pvc'}">
            <i class="material-icons">show_chart</i>
          </button>
        </div>
        <div class="gauge-chart-wrapper" [ngClass]="{'active': currentPvcChart === 'weight'}">
          <test-empty-gauge-chart
            unit="kg"
            title="{{ 'Weight'|translate }}"
            [subject]="subject"
            [data]="pvc.weight"
            [dataBorg]="-1"
          ></test-empty-gauge-chart>
          <button mat-mini-fab color="secondary" (click)="onPvcChartSelectorClicked('weight')"
                  [ngClass]="{'active': currentPvcChart === 'weight'}">
            <i class="material-icons">show_chart</i>
          </button>
        </div>
        <div class="gauge-chart-wrapper" [ngClass]="{'active': currentPvcChart === 'size'}">
          <test-empty-gauge-chart
            unit="cm"
            title="{{ 'Size'|translate }}"
            [subject]="subject"
            [data]="pvc.size"
            [dataBorg]="-1"
          ></test-empty-gauge-chart>
          <button mat-mini-fab color="secondary" (click)="onPvcChartSelectorClicked('size')"
                  [ngClass]="{'active': currentPvcChart === 'size'}">
            <i class="material-icons">show_chart</i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="horizontal-scroll-wrapper test-bloc-container">
    <div class="graph-min-600 w-full">
      <mat-card class="chart-wrapper" style="padding-top: 10px">
        <test-multi-line-chart
          [ngStyle]="{'display': currentPvcChart === 'pvc' ? 'block' : 'none'}"
          title="{{ 'PvcTooltipOffset'|translate }}"
          [data]="pvcOffsetSeries"
          [dataAsArray]="true"
          [yMax]="10"
          (pointClickEvent)="onPvcPointClicked($event)"
          [subject]="subject"
          [graphClass]="graphClass"
        ></test-multi-line-chart>
        <test-multi-line-chart
          [ngStyle]="{'display': currentPvcChart === 'weight' ? 'block' : 'none'}"
          unit="kg"
          title="{{ 'Weight'|translate }}"
          [data]="pvcActiveSeries"
          [dataAsArray]="true"
          (pointClickEvent)="onPvcPointClicked($event)"
          [subject]="subject"
          [graphClass]="graphClass"
        ></test-multi-line-chart>
        <test-multi-line-chart
          [ngStyle]="{'display': currentPvcChart === 'size' ? 'block' : 'none'}"
          unit="cm"
          title="{{ 'Size'|translate }}"
          [data]="pvcActiveSeries"
          [dataAsArray]="true"
          (pointClickEvent)="onPvcPointClicked($event)"
          [subject]="subject"
          [graphClass]="graphClass"
        ></test-multi-line-chart>
      </mat-card>
    </div>
  </div>
</div>

<div class="container" *ngIf="!isPvcTest && !is401 && !is404 && !isLoading && (data$ | async) as data">
  <ng-container *ngFor="let m of data.selected">
    <div class="horizontal-scroll-wrapper test-bloc-container tests-header">
      <mat-card-header>
        <div class="header-wrapper">
          <mat-card-subtitle>
            <div class="top-header">
              <mat-chip-set>
                <mat-chip><span>{{ date|appDate:'mediumDate' || '-' }}</span></mat-chip>
              </mat-chip-set>
              <div>
                <button class="edit-delete-measure" mat-mini-fab color="secondary" [matMenuTriggerFor]="secondaryMenu">
                  <i class="material-icons">
                    more_vert
                  </i>
                </button>
                <mat-menu #secondaryMenu="matMenu">
                  <button
                    [disabled]="!rights.EDIT"
                    mat-menu-item
                    (click)="edit(m.measureId)">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'Edit'|translate }}</span>
                  </button>
                  <button
                    [disabled]="!rights.DELETE"
                    mat-menu-item
                    (click)="delete(m.measureId)">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'Delete'|translate }}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </mat-card-subtitle>
        </div>

        <!--      TODO : FIX COMMENT -->
        <div class="test-comment">
          {{ m.comment }}
        </div>
      </mat-card-header>

      <div class="separator"></div>

      <div class="mt-20">
        <div class="mb-40">
          <div class="borg-wrapper">
                <span [ngClass]="{'active': currentMeasure === 'borg'}">
                    {{ 'borg_results'|translate }}
                </span>
            <button mat-mini-fab color="secondary" (click)="onChartSelectorClicked('borg')"
                    [ngClass]="{'active': currentMeasure === 'borg'}">
              <i class="material-icons">
                show_chart
              </i>
            </button>
          </div>
        </div>

        <div>
          <div class="charts" fxLayout="row" fxLayoutAlign="space-evenly center">
            <div *ngFor="let metric of (metrics$ | async); let last = last" class="graph-min-800">
              <div class="gauge-chart-wrapper" [ngClass]="{'active': currentMeasure === metric.id}">
                <ng-container *ngIf="metric.borg">
                  <test-gauge-chart
                    unit="{{ metric.unit }}"
                    title="{{ metric.name }}"
                    [subject]="subject"
                    [data]="m.measures[metric.id]?.gaugeValue"
                    [dataBorg]="m.measures[metric.id]?.borg"
                  ></test-gauge-chart>
                </ng-container>
                <ng-container *ngIf="!metric.borg">
                  <test-empty-gauge-chart
                    unit="{{ metric.unit }}"
                    title="{{ metric.name }}"
                    [subject]="subject"
                    [data]="m.measures[metric.id]?.gaugeValue"
                    [dataBorg]="0"
                  ></test-empty-gauge-chart>
                </ng-container>
                <button mat-mini-fab color="secondary" (click)="onChartSelectorClicked(metric.id)">
                  <i class="material-icons">
                    show_chart
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </ng-container>

  <div class="horizontal-scroll-wrapper test-bloc-container">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="graph-min-600 w-full">
      <mat-card class="chart-wrapper">
        <test-multi-line-borg-chart
          title="{{ 'borg_results' | translate }}"
          [ngStyle]="{'display':currentMeasure === 'borg' ? 'block' : 'none' }"
          [data]="(data$ | async)?.series.borg"
          (pointClickEvent)="onPointClickedEvent($event)"
          [subject]="subject"
          [currentSerieCategory]="currentSerieCategory"
          [graphClass]="graphClass"
        ></test-multi-line-borg-chart>
        <ng-container *ngFor="let metric of (metrics$ | async)">
          <test-multi-line-chart
            *ngIf="!metric.grouped"
            unit="{{ metric.unit }}"
            title="{{ metric.name }}"
            [ngStyle]="{'display':currentMeasure === metric.id ? 'block' : 'none' }"
            [data]="(data$ | async)?.series.measures[metric.id]"
            [dataAsArray]="false"
            (pointClickEvent)="onPointClickedEvent($event)"
            [subject]="subject"
            [currentSerieCategory]="currentSerieCategory"
            [graphClass]="graphClass"
          ></test-multi-line-chart>
          <test-multi-line-chart
            *ngIf="metric.grouped"
            unit="{{ metric.unit }}"
            title="{{ metric.name }}"
            [ngStyle]="{'display':currentMeasure === metric.id ? 'block' : 'none' }"
            [data]="(data$ | async)?.series.measures | groupedMeasureValues: metric.grouped"
            [dataAsArray]="true"
            (pointClickEvent)="onPointClickedEvent($event)"
            [subject]="subject"
            [currentSerieCategory]="currentSerieCategory"
            [graphClass]="graphClass"
          ></test-multi-line-chart>
        </ng-container>
      </mat-card>
    </div>
  </div>
</div>

<div class="fab-right">
  <ng-container *ngIf="(rights.ADD || rights.EDIT || rights.DELETE) && !isMobile">
    <main-action
      [disabled]="!rights.ADD"
      [title]="'TestNewMeasure' | translate"
      [icon]="'add'"
      (click)="add()"
    >
    </main-action>
  </ng-container>
  <full-width-loader *ngIf="isLoading"></full-width-loader>
</div>
